/**
 * Checks if the file type is valid based on its extension.
 * @param {string} filePath - The file path or URL.
 * @returns {boolean} - Returns true if the file type is valid (pdf, png, jpg, jpeg).
 */
export const isValidFile = (filePath) => {
    if (!filePath) return false;
    const allowedExtensions = ['png', 'jpg', 'jpeg'];
    const fileExtension = filePath.split('.').pop().toLowerCase();
    return allowedExtensions.includes(fileExtension);
  };
  
  /**
   * Returns the appropriate file path or default path based on file validity.
   * @param {string} filePath - The file path or URL.
   * @param {string} defaultPath - The default image path to use if the file is not valid.
   * @returns {string} - Returns the file path if valid, otherwise the default path.
   */
  export const getFilePath = (filePath, defaultPath) => {
    return isValidFile(filePath) ? filePath : defaultPath;
  };